var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 57,
    viewBox: "0 0 170 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 5022",
    clipPath: "url(#clip0_1122_7108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.8749 42.6852C33.7652 43.3004 31.7081 43.6086 28.7036 43.6086C26.3996 43.6086 24.8556 42.9536 24.0728 41.6435L15.9266 28.3749C15.186 27.1468 14.5781 26.287 14.1026 25.7958C13.6295 25.3045 13.1061 24.977 12.5301 24.8133C11.9541 24.6495 11.0901 24.5676 9.93813 24.5676H9.50842V42.9945H0V0H9.50842V18.304H12.2832L24.3196 0H34.3812L20.2465 20.5739C21.9345 21.7633 23.4568 23.5248 24.8133 25.8595L34.8749 42.6852Z",
    fill: "#4877EF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M53.3353 43.6087C48.3548 43.6087 44.4966 42.0746 41.7606 39.0054C39.0235 35.9338 37.6555 31.6126 37.6555 26.0415C37.6555 20.4739 39.0235 16.1753 41.7606 13.1459C44.4966 10.1142 48.3548 8.59717 53.3353 8.59717C58.3146 8.59717 62.1729 10.1142 64.91 13.1459C67.6459 16.1753 69.015 20.4739 69.015 26.0415C69.015 31.6126 67.6459 35.9338 64.91 39.0054C62.1729 42.0746 58.3146 43.6087 53.3353 43.6087ZM53.3353 37.7135C55.5992 37.7135 57.2346 36.7924 58.2403 34.9479C59.2483 33.1045 59.7535 30.1354 59.7535 26.0415C59.7535 21.9875 59.2483 19.0501 58.2403 17.2306C57.2346 15.4089 55.5992 14.4969 53.3353 14.4969C51.0702 14.4969 49.4336 15.3975 48.4256 17.1988C47.4199 19.0001 46.9171 21.9477 46.9171 26.0415C46.9171 30.1354 47.4199 33.1045 48.4256 34.9479C49.4336 36.7924 51.0702 37.7135 53.3353 37.7135Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M92.6575 8.59717C97.0575 8.59717 100.39 10.0209 102.655 12.8684C104.919 15.7136 106.052 19.8996 106.052 25.4274C106.052 29.03 105.393 32.2039 104.077 34.9479C102.76 37.6931 100.907 39.823 98.518 41.3388C96.1318 42.8524 93.3752 43.6087 90.2484 43.6087C88.5205 43.6087 86.4005 43.2595 83.8897 42.5625V57.0001H74.7561V22.1114C74.7561 18.7943 74.6213 16.3891 74.3538 14.8971C74.0853 13.4029 73.5401 12.1213 72.7173 11.0535C73.8693 10.3985 75.0921 9.88787 76.3881 9.52056C77.6864 9.15097 78.9115 8.96561 80.0635 8.96561C80.9286 8.96561 81.628 9.25218 82.1617 9.82532C82.6977 10.3985 83.1091 11.2798 83.396 12.4681C85.8645 9.88787 88.9513 8.59717 92.6575 8.59717ZM88.9502 37.7135C91.5033 37.7135 93.4484 36.6696 94.7832 34.5795C96.1204 32.4905 96.7901 29.4394 96.7901 25.4274C96.7901 21.619 96.2963 18.825 95.3089 17.0441C94.3215 15.2645 92.7581 14.374 90.6187 14.374C89.3022 14.374 88.0268 14.6822 86.7925 15.2974C85.5582 15.9104 84.5902 16.6666 83.8897 17.5672V36.6082C85.5777 37.3451 87.2645 37.7135 88.9502 37.7135Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M141.731 23.8945C141.731 24.4677 141.627 25.7572 141.42 27.7609H119.569C119.776 30.8722 120.527 33.2899 121.823 35.0116C123.118 36.731 124.815 37.5907 126.915 37.5907C127.863 37.5907 128.655 37.4679 129.292 37.2223C129.929 36.9766 130.587 36.5377 131.267 35.9031C131.946 35.2663 132.841 34.2326 133.951 32.8009C134.157 32.4711 134.591 32.3051 135.249 32.3051C135.946 32.3051 136.8 32.5416 137.809 33.0147C138.817 33.4855 139.898 34.1507 141.05 35.0116C138.373 40.743 133.663 43.6087 126.915 43.6087C121.731 43.6087 117.656 42.0428 114.691 38.9098C111.729 35.778 110.248 31.4886 110.248 26.0415C110.248 22.4787 110.917 19.3867 112.255 16.7667C113.592 14.1466 115.506 12.1304 117.996 10.7169C120.486 9.30449 123.438 8.59717 126.851 8.59717C131.584 8.59717 135.247 9.92881 137.841 12.5909C140.434 15.2542 141.731 19.0217 141.731 23.8945ZM132.469 22.6027C132.469 17.1169 130.536 14.374 126.668 14.374C124.694 14.374 123.108 15.07 121.914 16.4619C120.722 17.8538 119.982 19.9007 119.692 22.6027H132.469Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M164.322 8.78369C166.297 8.78369 167.737 9.20445 168.642 10.0437C169.547 10.8807 170 12.2214 170 14.0648C170 14.763 169.906 15.4498 169.721 16.1253C169.538 16.7985 169.282 17.3205 168.953 17.6901C168.459 17.4024 167.903 17.1977 167.285 17.076C166.669 16.9521 165.785 16.8895 164.633 16.8895C161.957 16.8895 159.97 17.7083 158.672 19.3458C157.376 20.9834 156.729 23.4829 156.729 26.8421V42.9946H147.596V9.21127H156.729V13.6963C157.552 12.0986 158.622 10.8807 159.938 10.0437C161.255 9.20445 162.715 8.78369 164.322 8.78369Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1122_7108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0c254bba62c0c0dff8c5b779fbd4740e.svg";
export { ForwardRef as ReactComponent };